import {
  AlertTriangle,
  Users,
  FileText,
  Calendar,
  BarChart3,
  GraduationCap,
  Building2,
  ClipboardList,
  HardHat,
  MessageSquare,
} from 'lucide-react';

export const COMMAND_TEMPLATES = [
  {
    id: 'show_workers',
    pattern: 'Show workers',
    description: 'Open the worker roster and profiles',
    category: 'People',
    route: '/workers',
    keywords: ['workers', 'worker', 'crew', 'team'],
  },
  {
    id: 'show_incidents',
    pattern: 'Show incidents',
    description: 'Review incident reports and near misses',
    category: 'Safety',
    route: '/incidents',
    keywords: ['incidents', 'incident', 'near miss', 'safety'],
  },
  {
    id: 'show_training',
    pattern: 'Show training',
    description: 'View training compliance and modules',
    category: 'Training',
    route: '/training',
    keywords: ['training', 'certification', 'certs', 'compliance'],
  },
  {
    id: 'show_projects',
    pattern: 'Show projects',
    description: 'Open the jobsite portfolio',
    category: 'Projects',
    route: '/projects',
    keywords: ['projects', 'project', 'jobsite', 'jobsites', 'site'],
  },
  {
    id: 'show_assets',
    pattern: 'Show assets',
    description: 'Open the asset registry',
    category: 'Assets',
    route: '/assets',
    keywords: ['assets', 'equipment', 'tools'],
  },
  {
    id: 'show_reports',
    pattern: 'Generate report',
    description: 'Open reports and exports',
    category: 'Reports',
    route: '/reports',
    keywords: ['report', 'reports', 'export'],
  },
  {
    id: 'show_schedule',
    pattern: 'Show schedule',
    description: 'Open the schedule view',
    category: 'Schedule',
    route: '/schedule',
    keywords: ['schedule', 'calendar'],
  },
  {
    id: 'show_analytics',
    pattern: 'Show analytics',
    description: 'Open analytics and trends',
    category: 'Analytics',
    route: '/analytics',
    keywords: ['analytics', 'trends', 'metrics'],
  },
  {
    id: 'show_foreman',
    pattern: 'Show foreman',
    description: 'Open the foreman dashboard',
    category: 'Foreman',
    route: '/foreman',
    keywords: ['foreman', 'supervisor'],
  },
  {
    id: 'notify_workers',
    pattern: 'Notify workers',
    description: 'Send a broadcast message to workers',
    category: 'Comms',
    action: 'notify_workers',
    keywords: ['notify', 'message', 'broadcast', 'send'],
  },
  {
    id: 'schedule_meeting',
    pattern: 'Schedule meeting',
    description: 'Schedule a meeting or call',
    category: 'Operations',
    action: 'schedule_meeting',
    keywords: ['schedule meeting', 'meeting', 'call'],
  },
];

export const COMMAND_QUICK_ACTIONS = [
  {
    id: 'report',
    icon: AlertTriangle,
    label: 'Report',
    command: 'Show incidents',
    route: '/incidents',
  },
  {
    id: 'workers',
    icon: Users,
    label: 'Workers',
    command: 'Show workers',
    route: '/workers',
  },
  {
    id: 'foreman',
    icon: HardHat,
    label: 'Foreman',
    command: 'Show foreman',
    route: '/foreman',
  },
  {
    id: 'sites',
    icon: Building2,
    label: 'Sites',
    command: 'Show projects',
    route: '/projects',
  },
  {
    id: 'assets',
    icon: ClipboardList,
    label: 'Assets',
    command: 'Show assets',
    route: '/assets',
  },
  {
    id: 'reports',
    icon: FileText,
    label: 'Reports',
    command: 'Generate report',
    route: '/reports',
  },
  {
    id: 'schedule',
    icon: Calendar,
    label: 'Schedule',
    command: 'Show schedule',
    route: '/schedule',
  },
  {
    id: 'analytics',
    icon: BarChart3,
    label: 'Analytics',
    command: 'Show analytics',
    route: '/analytics',
  },
  {
    id: 'training',
    icon: GraduationCap,
    label: 'Training',
    command: 'Show training',
    route: '/training',
  },
  {
    id: 'message',
    icon: MessageSquare,
    label: 'Message',
    command: 'Notify workers',
  },
];
